import isBrowser from '@/helpers/isBrowser';

const createLegacyCookie = (name: string, value: string, days?: number): string => {
  if (!isBrowser()) {
    return '';
  }

  const parts = [];
  parts.push(`${name}=${value}`);

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    parts.push(`expires=${date.toUTCString()}`);
  }

  const isSecureContext = window.location.protocol === 'https:';
  parts.push('path=/');
  parts.push(isSecureContext ? 'SameSite=None' : 'SameSite=Lax');
  if (isSecureContext) {
    parts.push('Secure');
  }

  const cookie = parts.join('; ');
  document.cookie = cookie;

  return cookie;
};

export default createLegacyCookie;
